module.exports = __webpack_public_path__ + "media/images/games/clash-royale/card-legendary-eeed7ade42f43a34417b97a08a8cb59e.png";